import React from 'react';

export default function Toast({ message = '', type = 'success', visible = false, className = '' }) {
  if (!visible || !message) return null;
  const bgClass = type === 'error' ? 'bg-red-600' : 'bg-green-600';
  return (
    <div className={`fixed top-4 right-4 z-60 max-w-sm px-4 py-2 rounded shadow-lg text-white ${bgClass} ${className}`}>
      {message}
    </div>
  );
}
